import { observer } from 'mobx-react';
import * as React from 'react';

const styles = require('./SpamOptionFull.scss');

export interface SpamOptionIconBarProps {
    iconButtons: JSX.Element[];
}

@observer
export default class SpamOptionIconBar extends React.Component<SpamOptionIconBarProps, {}> {
    render() {
        return <div className={styles.iconBar}>{this.props.iconButtons}</div>;
    }
}
